/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
    Injectable,
    ModuleWithProviders,
    NgModule
} from '@angular/core';
import {Subject} from 'rxjs';

export interface IndividualConfig {
    disableTimeOut?: boolean;
    timeOut?: number;
    [key: string]: unknown;
}

export interface ActiveToast<T> {
    toastId: number;
    message?: string;
    title?: string;
    toastRef?: T;
    onTap: Subject<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ToastrService {
    private nextToastId = 1;

    success(message?: string, title?: string, _override?: Partial<IndividualConfig>): ActiveToast<unknown> {
        return this.createToast(message, title);
    }

    error(message?: string, title?: string, _override?: Partial<IndividualConfig>): ActiveToast<unknown> {
        return this.createToast(message, title);
    }

    info(message?: string, title?: string, _override?: Partial<IndividualConfig>): ActiveToast<unknown> {
        return this.createToast(message, title);
    }

    warning(message?: string, title?: string, _override?: Partial<IndividualConfig>): ActiveToast<unknown> {
        return this.createToast(message, title);
    }

    private createToast(message?: string, title?: string): ActiveToast<unknown> {
        return {
            toastId: this.nextToastId++,
            message,
            title,
            onTap: new Subject<void>()
        };
    }
}

@NgModule({})
export class ToastrModule {
    static forRoot(_config?: Partial<IndividualConfig>): ModuleWithProviders<ToastrModule> {
        return {
            ngModule: ToastrModule,
            providers: [ToastrService]
        };
    }
}

